export const obterValor = (item) => item?.precooferta || item?.preco || 0;
